// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButtonBase: {
      styleOverrides: {
        containedInherit: {
          "&[type=button]:focus": {
            backgroundColor: "inherited",
            borderColor: "inherited",
            color: "inherited",
          },
        },

        containedPrimary:{
            "&[type=button]:focus": {
                backgroundColor: "inherited",
                borderColor: "inherited",
                color: "inherited",
              },
          }

      },
    },
  };
}
